<template>
  <div class="row-wrapper" v-if="showAmountCondition">
    <hr>
    <b-row>
      <b-col class="bTxt consumption-added-promo-volume">
        <div><slot name="txtCurrentTariffAddedVolume">{{ description }}</slot>
          <br>
          <span class="promo-expiry-date " v-if="!isPermanentDate(expirationDate)">
            gültig bis {{ expirationDateFormatted }}
          </span>
          <span class="promo-expiry-date " v-else>
            <slot name="txtPromoPermanent">Dauerhaft gültig</slot>
          </span>
        </div>
      </b-col>
      <b-col class="bPriceSum">{{ amount }} {{ unit }}</b-col>
    </b-row>
  </div>
</template>

<script>
import promoContext from '@/mixins/promoContext'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import useFeature from '@/mixins/useFeature'
import { mapActions } from 'vuex'
import date from '@/mixins/validators/date'

export default {
  name: 'PromoConsumptionProgressAddedVolume',
  data () {
    return {
      showAmount: false,
      expirationDateFormatted: ''
    }
  },
  mixins: [
    promoContext,
    useFeature('showFeaturePromotion'),
    dateFormatter,
    date
  ],
  props: {
    default: {
      required: true,
      type: Boolean
    },
    description: {
      required: false,
      type: String
    },
    amount: {
      required: true,
      type: Number
    },
    unit: {
      required: true,
      type: String
    },
    expirationDate: {
      required: false,
      type: String
    }
  },
  created () {
    this.getActivePromotions()
  },
  mounted () {
    if (typeof this.amount === 'number') {
      this.showAmount = true
      this.expirationDateFormatted = this.dateFormatter(this.expirationDate)
      if (this.expirationDateFormatted !== false) {
        this.showExpirationDate = true
      }
    }
  },
  computed: {
    showAmountCondition () {
      return this.showAmount && this.showFeaturePromotion
    }
  },
  methods: {
    ...mapActions('promotion/activePromotions', [
      'getActivePromotions'
    ])
  }
}
</script>
